import notifications from './notifications';

function showLargeImagePanel() {
  document.getElementById('largeImgPanel').style.visibility = 'visible';
}

const showImage = (event) => {
  const { imgNr } = event.target.dataset;
  const liTarget = `li[data-slide-to='${imgNr}']`;
  $(liTarget).trigger('click');
  showLargeImagePanel();
  notifications.unselectAll();
};

function showLargeSingleImagePanel() {
  document.getElementById('largeSingleImgPanel').style.visibility = 'visible';
}

const showSingleImage = (event) => {
  const imgSrc = event.target.src;
  document.getElementById('largeImg').src = imgSrc;
  showLargeSingleImagePanel();
  notifications.unselectAll();
};

$.fn.carouselHeights = () => {
  const items = $(this); // grab all slides
  const heights = []; // create empty array to store height values
  let tallest; // create variable to make note of the tallest slide

  const normalizeHeights = () => {
    items.each(
      () => { // add heights to array
        heights.push($(this).height());
      },
    );

    tallest = Math.max.apply(null, heights); // cache largest value
    items.each(
      () => {
        $(this).css('min-height', `${tallest}px`);
      },
    );
  };

  normalizeHeights();

  $(window).on(
    'resize orientationchange',
    () => {
      // reset vars
      tallest = 0;
      heights.length = 0;

      items.each(
        () => {
          $(this).css('min-height', '0'); // reset min-height
        },
      );
      normalizeHeights(); // run it again
    },
  );
};

// On load...
$(() => {
  // Fix carousel height.
  $('#carousel-hero .item').carouselHeights();
});

export default { showImage, showSingleImage };
